<template>
  <div class="sprint-label is-flex">
    <div class="sprint-label__marker">
      <icon
        v-if="sprint.continuousSprint"
        data="@icon/continuous-sprint.svg"
        class="continuous-sprint__icon"
        :class="[`is-${sprint.status.toLowerCase()}`]"
        :fill="true"
        :width="iconSize"
        :height="iconSize"
      />
      <icon
        v-else-if="sprint.zeroSprint"
        data="@icon/zero-sprint.svg"
        class="zero-sprint__icon"
        :class="[`is-${sprint.status.toLowerCase()}`]"
        :fill="true"
        :width="iconSize"
        :height="iconSize"
      />
      <div
        v-else
        class="dot dot_sm"
        :class="[`is-${sprint.status.toLowerCase()}`]"
      />
    </div>
    {{ label }}
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import { Sprint } from "@/models"

@Options({
  name: "SprintLabel",
  components: {}
})
export default class SprintLabel extends Vue {
  @Prop({ required: true }) readonly sprint: Sprint
  @Prop({ default: false }) readonly shortLabel: boolean
  @Prop({ default: "var(--icon-24)" }) readonly iconSize: string

  get label(): string {
    if (this.shortLabel) {
      return `S #${this.sprint.sequenceNumber}`
    }

    return `Sprint${this.sprint.zeroSprint ? " Zero" : ""} #${this.sprint.sequenceNumber}`
  }
}
</script>
